<ng-template #content let-offcanvas>
  <div class="d-flex justify-content-between align-items-center px-3 py-4">
    @if (!isWlmhEnabled) {
      <save-btn
        isWlmhEnabled
        [label]="'front.save-btn.add-new-task'"
        (click)="openDialog()"
      ></save-btn>
    }

    <div class="close-box-bar">
      <app-icons-image
        class="cursor-pointer hover-pin"
        [name]="isTaskDrawerPinned() ? 'keep' : 'keep_grey'"
        (click)="pinUnpinDrawer()"
      ></app-icons-image>
      <app-icons-image
        class="cursor-pointer icon-size-transform hover-close"
        name="close_grey"
        (click)="dismissDrawer()"
      ></app-icons-image>
    </div>
  </div>
  <div class="position-relative">
    <nav
      #nav="ngbNav"
      [(activeId)]="activeId"
      class="nav-tabs position-sticky top-0 bg-white z-1"
      ngbNav
    >
      <ng-container [ngbNavItem]="1">
        <a
          [ngClass]="{ active: activeId === 1 }"
          class="task-nav-link"
          ngbNavLink
          >{{ "front.task-drawer.in-progress" | translate | uppercase }}</a
        >
        <ng-template ngbNavContent>
          @for (task of inProgressTasks(); track task) {
            <app-task-item [task]="task" [canvasBody]="canvasBody" />
          }
          @if (showNoInProgressTasks()) {
            <div class="drawer-empty-state text-center py-4">
              {{ "front.task-drawer.empty" | translate }}
            </div>
          }
        </ng-template>
      </ng-container>
      <ng-container [ngbNavItem]="2">
        <button
          [ngClass]="{ active: activeId === 2 }"
          class="task-nav-link"
          ngbNavLink
        >
          {{ "front.task-drawer.closed" | translate | uppercase }}
        </button>
        <ng-template ngbNavContent>
          @for (task of completedTasks(); track task) {
            <app-task-item [task]="task" />
          }
          @if (showNoCompletedTasks()) {
            <div class="drawer-empty-state text-center py-4">
              {{ "front.task-drawer.empty" | translate }}
            </div>
          }
        </ng-template>
      </ng-container>
    </nav>

    <div
      class="offcanvas-body"
      #canvasBody
      (scroll)="onScroll()"
      [ngStyle]="{ 'padding-top': isScrollingDown ? '0' : '1rem' }"
    >
      @if (drawerLoading()) {
        <div class="drawer-loading-state" aria-live="polite">
          <app-loading-spinner />
        </div>
      } @else {
        <div>
          <div [ngbNavOutlet]="nav" class="mt-2"></div>
          @if (isLoading) {
            <div class="d-flex justify-content-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

@if (!isTaskDrawerOpen()) {
  <section
    style="
      margin-left: -25px;
      height: 100%;
      padding: 10px;
      background-color: #fff;
      border-top-left-radius: 20px;
      border-bottom-left-radius: 20px;
    "
  >
    <section class="p-1" style="background-color: #0032a0; border-radius: 50%">
      <img
        (click)="openDrawer(content)"
        alt="right"
        class="cursor-pointer"
        height="32"
        ngSrc="assets/images/svg/assignment.svg"
        width="32"
      />
    </section>
  </section>
}
